import axios from "axios";

export const API_URL = import.meta.env.VITE_APP_API_URL;
export const BRANDED_URL = import.meta.env.VITE_APP_BRANDED_URL;
export const AMPLIFY_APP_ID = import.meta.env.VITE_APP_AMPLIFY_APP_ID;
const COMMIT_ID = import.meta.env.VITE_APP_COMMIT_ID;

const apiClient = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

// Request interceptor — injects auth token + app ID
apiClient.interceptors.request.use((config) => {
  config.headers["X-app-id"] = COMMIT_ID;

  // Token priority: explicit Authorization header on config > sessionStorage sessionToken
  if (!config.headers.Authorization) {
    const stored = sessionStorage.getItem("sessionToken");
    if (stored) {
      try {
        const { uuid } = JSON.parse(stored);
        config.headers.Authorization = `Bearer ${uuid}`;
      } catch {
        /* no valid token */
      }
    }
  }

  return config;
});

// Helper to build auth config for explicit token override
const withToken = (token) => ({
  headers: { Authorization: `Bearer ${token}` },
});

// --- Auth endpoints (no explicit token needed) ---

export const loginConsumer = async (payload, config) => {
  const response = await apiClient.post("/consumer/login", payload, config);
  return response.data;
};

export const sendOtpEmail = async (payload) => {
  const response = await apiClient.post("/consumer/otp-email", payload);
  return response.data;
};

export const registerConsumer = async (payload) => {
  const response = await apiClient.post("/consumer/register", payload);
  return response.data;
};

// --- Registration sub-steps (require explicit registerData token) ---

export const verifySchufa = async (payload, token) => {
  const response = await apiClient.post(
    "/consumer/verify-schufa",
    payload,
    withToken(token)
  );
  return response.data;
};

export const sendOtpSms = async (payload, token) => {
  const response = await apiClient.post(
    "/consumer/otp-sms",
    payload,
    withToken(token)
  );
  return response.data;
};

export const verifyPhone = async (payload, token) => {
  const response = await apiClient.post(
    "/consumer/verify-phone",
    payload,
    withToken(token)
  );
  return response.data;
};

export const confirmRegistration = async (payload, token) => {
  const response = await apiClient.post(
    "/consumer/confirm",
    payload,
    withToken(token)
  );
  return response.data;
};

// --- Password reset ---

export const requestPasswordToken = async (payload) => {
  const response = await apiClient.post("/consumer/password-token", payload);
  return response.data;
};

export const resetPassword = async (payload, token) => {
  const response = await apiClient.post(
    "/consumer/password-reset",
    payload,
    withToken(token)
  );
  return response.data;
};


export const migrateStatus = async (payload, token) => {
  const response = await apiClient.post(
    "/consumer/registration-status",
    payload,
    withToken(token)
  );
  return response.data;
};
